import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const PageMeta = props => {
  return (
    <React.Fragment>
      <Helmet>
        {props.meta_title ? (
          <title>{props.meta_title}</title>
        ) : (
          <title>
            Featured Customers | Find B2B & SaaS Software & Services - Reviews,
            Testimonials & Case Studies
          </title>
        )}
        {props.meta_keywords ? (
          <meta name="keywords" content={props.meta_keywords} />
        ) : null}
        {props.meta_description ? (
          <meta name="description" content={props.meta_description} />
        ) : null}
        {props.website_ld_schema ? (
          <script type="application/ld+json">{props.website_ld_schema}</script>
        ) : null}
        {props.organization_ld_schema ? (
          <script type="application/ld+json">
            {props.organization_ld_schema}
          </script>
        ) : null}
        {props.corporation_ld_schema ? (
          <script type="application/ld+json">
            {props.corporation_ld_schema}
          </script>
        ) : null}
      </Helmet>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return { tracking: state.webSiteCommonData.common_tracking };
};

export default connect(mapStateToProps)(PageMeta);
